theme.socialShare = (function(){
  const selectors = {
    link: '.copy-link',
    delay: 2500
  };

  const init = () => {
    let links = document.querySelectorAll(selectors.link);
    links.forEach(link => link.addEventListener('click', function(e){
      e.preventDefault();
      theme.utils.copyToClipboard(link.getAttribute('href'), function(){
        link.classList.add('tooltip-shown');
        setTimeout(() => {
          link.classList.remove('tooltip-shown');          
        }, selectors.delay);
      })
    }))
  }

  return {
    selectors,
    init
  }
})();